import api from './api';

class UniversityService {
  /**
   * Get paginated list of universities
   * @param {number} page - Page number (0-based)
   * @param {number} size - Page size
   * @param {string} search - Search query
   * @returns {Promise} API response
   */
  async getUniversities(page = 0, size = 10, search = '') {
    try {
      const params = new URLSearchParams({
        page: page.toString(),
        size: size.toString(),
      });
      
      if (search?.trim()) {
        params.append('search', search.trim());
      }

      const response = await api.get(`/admin/universities?${params}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  /**
   * Get university by ID
   * @param {number} id - University ID
   * @returns {Promise} API response
   */
  async getUniversity(id) {
    try {
      const response = await api.get(`/admin/universities/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  /**
   * Create new university
   * @param {Object} data - University data
   * @returns {Promise} API response
   */
  async createUniversity(data) {
    try {
      const response = await api.post('/admin/universities', data);
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  /**
   * Update university
   * @param {number} id - University ID
   * @param {Object} data - University data
   * @returns {Promise} API response
   */
  async updateUniversity(id, data) {
    try {
      const response = await api.put(`/admin/universities/${id}`, data);
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  /**
   * Delete university
   * @param {number} id - University ID
   * @returns {Promise} API response
   */
  async deleteUniversity(id) {
    try {
      const response = await api.delete(`/admin/universities/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  }
}

const universityService = new UniversityService();
export default universityService;